import { FormControl } from "@angular/forms";

export interface ChangePasswordRequest {
  username: string;
  oldPassword: string;
  newPassword: string;
  changeType: ChangePasswordType;
}

export interface ChangePasswordRequestForm {
  username: FormControl<string>;
  oldPassword: FormControl<string>;
  newPassword: FormControl<string>;
  confirmPassword: FormControl<string>;
  changeType?: FormControl<ChangePasswordType>;
}


export enum ChangePasswordType{
  User = 'User',
  System = 'System',
  Reset = 'Reset'
}
